import { Injectable } from '@angular/core';
import { UrlConnectionEnum } from '../../enums/url-connection.enum';
import { HttpService } from '../http-service/http.service';
// import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class ReportService {

     constructor(private httpService: HttpService,
      // private sanitizer: DomSanitizer
     ) { }
      
    downloadRescuesReport(filtros: any) {
        this.httpService.getBlob(UrlConnectionEnum.GET_RESCUES_CSV_REPORT, filtros, this.httpService.setHeaderConfig(true))
        .subscribe({
            next: (res: Blob) => {
                // 1. Criamos um "endereço" na memória para o arquivo que chegou
                const blobUrl = window.URL.createObjectURL(res);
                
                // 2. Criamos um elemento de link (<a>) "invisível"
                const anchor = document.createElement('a');
                anchor.style.display = 'none';
                anchor.href = blobUrl;
                
                // 3. Definimos o nome do arquivo que o usuário verá
                anchor.download = `relatorio_${Date.now()}.xlsx`;
                
                // 4. CRÍTICO: Adicionamos o link ao documento (o navegador exige isso)
                document.body.appendChild(anchor);
                
                // 5. Simulamos o clique que você estava fazendo manualmente no Network
                anchor.click();
                
                // 6. Limpamos a bagunça: removemos o link e liberamos a memória RAM
                setTimeout(() => {
                    document.body.removeChild(anchor);
                    window.URL.revokeObjectURL(blobUrl);
                }, 100);
            },
            error: (err) => {
                console.error('O arquivo chegou, mas o navegador barrou o download:', err);
            }
        });
    }

    downloadDoctorReport(filtros: any) {
        this.httpService.getBlob(UrlConnectionEnum.GET_DOCTORS_CSV_REPORT, filtros, this.httpService.setHeaderConfig(true))
        .subscribe({
            next: (res: Blob) => {
                // 1. Criamos um "endereço" na memória para o arquivo que chegou
                const blobUrl = window.URL.createObjectURL(res);
                
                // 2. Criamos um elemento de link (<a>) "invisível"
                const anchor = document.createElement('a');
                anchor.style.display = 'none';
                anchor.href = blobUrl;
                
                // 3. Definimos o nome do arquivo que o usuário verá
                anchor.download = `relatorio_${Date.now()}.xlsx`;
                
                // 4. CRÍTICO: Adicionamos o link ao documento (o navegador exige isso)
                document.body.appendChild(anchor);
                
                // 5. Simulamos o clique que você estava fazendo manualmente no Network
                anchor.click();
                
                // 6. Limpamos a bagunça: removemos o link e liberamos a memória RAM
                setTimeout(() => {
                    document.body.removeChild(anchor);
                    window.URL.revokeObjectURL(blobUrl);
                }, 100);
            },
            error: (err) => {
                console.error('O arquivo chegou, mas o navegador barrou o download:', err);
            }
        });
    }

}

